const listenForResponseOnVoiceContent = () => {
  return null;
};

export default listenForResponseOnVoiceContent;
